import React from 'react';
import { withStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import pcGroup from '../../assets/images/pcGroup.svg';
const NotFound = (props) => {
  return (
      <div className={props.classes.container}>
        <div>
          <img src={pcGroup} alt='pc' />
        </div>
        <div className={props.classes.textBody}>
          <h3 className='title'>We couldn't find the page you're looking for</h3>
          <div className='description'>
            <p>Go back or click the link below to return to the home page</p>
          </div>
			<Link to='/' >Home</Link>
        </div>
      </div>      
  )
}

const styleSheet = theme => ({
  container: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    height: '90vh', 
    margin: '0 10%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    }
  },
  textBody: {
    textAlign: 'left',
    paddingLeft: '5%',
    fontFamily: 'Lato, sans-serif', 
    '& .title': {
      fontWeight: 'bold', 
      fontSize: '20px'
    },
    '& .description': {
      fontSize: '15px',
      fontWeight: 400,
      color: '#707070'
    }
  }
});
export default withStyles(styleSheet)(NotFound)